import { OnlineSales } from 'gw-edge-client';
import { useRecoilValue } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';

export const useWithdrawJob = (): {
    withdrawJob: () => Promise<void>;
} => {
    const { jobNumber, sessionId } = useRecoilValue(jobInfoAtom);

    const withdrawJob = async (): Promise<void> => {
        await OnlineSales.withdrawJob(jobNumber, sessionId);
    };

    return { withdrawJob };
};
